// @flow
import { PRODUCT_IMAGE_MAP } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_IMAGE_MAP } from 'Utils/request/requestDictionary';

type CMSProps = {
  resortId: string,
  title: string,
};

type GQLProps = {
  resort: Resort,
};

export const productImageMapResolver = {
  name: PRODUCT_IMAGE_MAP,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { resortId: productId } = props;
    const resortArgs = buildProductArgs(productId, location.urlParams);
    const query = `query {resort(${resortArgs}) {name mapUrl}}`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_IMAGE_MAP,
      strictErrors: false,
    });
  },
};
